module.exports = __webpack_public_path__ + "assets/img/264340c8b1cf593604dd263ba4c9c92b.svg";